var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ContentHeader',[_c('h1',[_vm._v("Fakturor")])]),_c('p',[_vm._v(" Lorem ipsum... ")]),_c('h2',[_vm._v("Faktura")]),_c('InvoicesList',{attrs:{"invoices":_vm.invoices}}),_c('AppMenu',{attrs:{"extraMenuAtBottom":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }